"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.perfNow = void 0;
const perfNow = () => typeof window !== 'undefined' && window.performance && window.performance.now ? window.performance.now() : Date.now();
exports.perfNow = perfNow;
//# sourceMappingURL=perfNow.js.map